module.exports = __webpack_public_path__ + "img/banner@2x.81f64eaf.png";